// extracted by mini-css-extract-plugin
module.exports = {"burgerButton":"BurgerIcon_burgerButton__31ELE","line":"BurgerIcon_line__2fxFy"};